var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    fillOpacity: 0,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#22272A",
    strokeWidth: 2,
    transform: "translate(16 16) scale(1 -1) translate(-16 -16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6375,11                C16.0938368,11 16.4861887,10.8384434 16.806066,10.518566                C17.1272052,10.1974268 17.2875,9.77150073 17.2875,9.25                C17.2875,8.76114533 17.1265795,8.35194745 16.806066,8.03143398                C16.4861887,7.71155664 16.0938368,7.55 15.6375,7.55                C15.1805725,7.55 14.7916832,7.7120372 14.4799081,8.03298215                C14.1685719,8.35347534 14.0125,8.76201636 14.0125,9.25                C14.0125,9.77065973 14.1679637,10.1958986 14.4799081,10.5170179                C14.7916832,10.8379628 15.1805725,11 15.6375,11 Z                M15.8,25                C16.3522847,25 16.8,24.5522847 16.8,24                L16.8,14                C16.8,13.4477153 16.3522847,13 15.8,13                C15.2477153,13 14.8,13.4477153 14.8,14                L14.8,24                C14.8,24.5522847 15.2477153,25 15.8,25 Z",
    fill: "#22272A",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.04a7635e499633c489bf4c9eff46af63.svg";
export { ForwardRef as ReactComponent };